import dayjs from 'dayjs';
/**
 * 日付共通クラス
 * @name DateUtils
 */
export default class DateUtils {
  /**
   * 日付を文字列にフォーマットする
   * @param target 対象の日付
   * @param format フォーマット文字列
   */
  public static format(target: Date, format: string): string {
    if (typeof target === 'string') {
      target = new Date(target);
    }
    return dayjs(target).format(format);
  }
}
